import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import Link from 'next/link';
import React from 'react';

import { business, description, stat, story } from './content';
import * as ST from './styled';

const About = () => {
    return (
        <ST.About>
            <ST.TopSection>
                <ST.TopContent>
                    <ST.Frame>
                        <ST.MainTitle>О Дом.ру</ST.MainTitle>
                        <ST.MainText>Мы делаем информацию доступной, общение приятным, а связь с близкими — постоянной.</ST.MainText>
                    </ST.Frame>
                </ST.TopContent>
            </ST.TopSection>
            <ST.Section>
                <ST.Grid>
                    <ST.SubTitle>Дом.ру&nbsp;&mdash; ведущий провайдер телекоммуникационных услуг и&nbsp;сервисов в&nbsp;России</ST.SubTitle>
                    <ST.StatBlockWrapper>
                        {stat.map(({ green, text }, index) => {
                            return (
                                <ST.StatBlock key={index}>
                                    <ST.GreenText>{green}</ST.GreenText>
                                    <ST.Text>{text}</ST.Text>
                                </ST.StatBlock>
                            );
                        })}
                    </ST.StatBlockWrapper>
                </ST.Grid>
            </ST.Section>
            <ST.Section bgColor={COLORS.outlineGrey}>
                <ST.Grid>
                    <ST.SectionHeading>История Дом.ру</ST.SectionHeading>
                    {story.map(({ year, text }, index) => {
                        return (
                            <ST.StoryBlock key={index}>
                                <ST.Paragraph>{year}</ST.Paragraph>
                                <ST.Text>{text}</ST.Text>
                            </ST.StoryBlock>
                        );
                    })}
                    <ST.Image src='/static/images/about/history_map-min.png' alt='О компании Дом.ру 1'></ST.Image>
                </ST.Grid>
            </ST.Section>
            <ST.Section bgColor='#fdf9f6'>
                <ST.Grid>
                    <ST.SectionHeading>Для бизнеса и частных лиц</ST.SectionHeading>
                    {business.map(({ icon, title, text, link }, index) => {
                        return (
                            <ST.BlockWithIcon key={index}>
                                <ST.Icon>{icon}</ST.Icon>
                                <ST.TextContent>
                                    <ST.BlockTitle>{title}</ST.BlockTitle>
                                    <ST.Text>{text}</ST.Text>
                                    <Link href={link.href} passHref><ST.Link>{link.text}</ST.Link></Link>
                                </ST.TextContent>
                            </ST.BlockWithIcon>
                        );
                    })}
                </ST.Grid>
                <ST.Image src='/static/images/about/services_woman.jpg' alt='О компании Дом.ру 6'></ST.Image>
            </ST.Section>
            <ST.Section>
                <ST.Grid>
                    <ST.SectionHeading>Вместе с подключением к Дом.ру вы получите</ST.SectionHeading>
                    <ST.ContentRow>
                        <ST.AdvWrapper>
                            {description.map(({ icon, title, text, link }, index) => {
                                if (link) {
                                    return (
                                        <ST.BlockWithIcon key={index}>
                                            <ST.Icon>{icon}</ST.Icon>
                                            <ST.TextContentAdv>
                                                <ST.BlockTitle>{title}</ST.BlockTitle>
                                                <ST.Text>{text}</ST.Text>
                                                <Link href={link.href} passHref><ST.Link>{link.text}</ST.Link></Link>
                                            </ST.TextContentAdv>
                                        </ST.BlockWithIcon>
                                    );
                                } else {
                                    return (
                                        <ST.BlockWithIcon key={index}>
                                            <ST.Icon>{icon}</ST.Icon>
                                            <ST.TextContentAdv>
                                                <ST.BlockTitle>{title}</ST.BlockTitle>
                                                <ST.Text>{text}</ST.Text>
                                            </ST.TextContentAdv>
                                        </ST.BlockWithIcon>
                                    );
                                }
                            })}
                        </ST.AdvWrapper>
                        <ST.ImageWrapper>
                            <ST.ImageAdv src='/static/images/about/advantages_girl.png' alt='О компании Дом.ру 7'></ST.ImageAdv>
                        </ST.ImageWrapper>
                    </ST.ContentRow>
                    <Link href='/reviews'><a>Отзывы о нашей сети</a></Link>
                </ST.Grid>
            </ST.Section>
            <ST.Section bgColor={COLORS.outlineGrey}>
                <ST.Grid>
                    <ST.SectionHeading>Отчетность</ST.SectionHeading>
                    <ST.Text>
                        Как одна из крупнейших российских компаний, при работе с инвесторами и акционерамы мы
                        стремимся предоставлять наиболее актуальную и важную информацию о деятельности компании.
                    </ST.Text>
                </ST.Grid>
                <ST.Image src='/static/images/about/investors-min.jpg' alt='О компании Дом.ру 4'/>
            </ST.Section>
            <ST.Section>
                <ST.Grid>
                    <ST.SectionHeading>Заходите в гости</ST.SectionHeading>
                    <ST.TextMB20>Наши офисы — в 57 городах России. Найти ближайший к вам офис можно в разделе
                        «<Link href='/service/contact'>
                            <ST.Link >Контакты</ST.Link>
                        </Link>».
                    </ST.TextMB20>
                    <ST.Gif src='/static/images/about/converted_file_15c3ad18.gif' alt='О компании Дом.ру 2'/>
                </ST.Grid>
            </ST.Section>
            <ST.Section bgColor={COLORS.outlineGrey}>
                <ST.LastGrid>
                    <ST.SectionHeading>Присоединяйтесь к команде</ST.SectionHeading>
                    <ST.TextMB20>У нас работает 22 000 сотрудников. Возможность обучения и развития как для начинающих, так и для опытных специалистов.</ST.TextMB20>
                    <ST.Button type={btnTypes.ACCENT} text='Посмотреть вакансии' href='https://job.ertelecom.ru/'/>
                </ST.LastGrid>
                <ST.ImageTeam src='/static/images/about/command_dom.jpg' alt='О компании Дом.ру 3'/>
            </ST.Section>
        </ST.About>
    );
};

export default About;
